import React from "react";

const DefaultLayout = (ComponentsObject) => {
    return <>{Object.keys(ComponentsObject).map((fieldKey, indexField) => {
        return ComponentsObject[fieldKey];
    })}</>;
}

export default DefaultLayout;